module.exports = __webpack_public_path__ + "static/media/icon_volleyball.83e477ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon_volleyball.png
// module id = 140
// module chunks = 0